import type { LucideIcon } from 'lucide-react'
import { Users, UserCheck, UserCog, FileText } from 'lucide-react'

export interface StatCardConfig {
  labelKey:
    | 'stats.totalPatients'
    | 'stats.activePatients'
    | 'stats.totalStaff'
    | 'stats.documentsThisMonth'
  icon: LucideIcon
  colorClass: string
}

export const statCardConfigs: StatCardConfig[] = [
  {
    labelKey: 'stats.totalPatients',
    icon: Users,
    colorClass: 'bg-blue-500/10 text-blue-500',
  },
  {
    labelKey: 'stats.activePatients',
    icon: UserCheck,
    colorClass: 'bg-green-500/10 text-green-500',
  },
  {
    labelKey: 'stats.totalStaff',
    icon: UserCog,
    colorClass: 'bg-purple-500/10 text-purple-500',
  },
  {
    labelKey: 'stats.documentsThisMonth',
    icon: FileText,
    colorClass: 'bg-orange-500/10 text-orange-500',
  },
]
